import axios from "../api";
export const getCollectedSync = async () => {
    const res = await axios.get("/user-players/collected/sync");
    return res.data;
};
// The app's in-app sync posts its pages here; a non-2xx throws.
export const postCollectedSyncPage = async (page) => {
    const res = await axios.post("/user-players/collected/sync", page);
    return res.data;
};
//# sourceMappingURL=collectedSync.js.map